import {RelationshipDefinition} from "../relationship/relationship-definition";
import {TableModel} from "../table/table-model";
import {FieldValidationScriptDefinition} from "./field-validation-script-definition";

export class FieldValidationScriptModel {
  private readonly definition: FieldValidationScriptDefinition;

  constructor(definition: FieldValidationScriptDefinition) {
    this.definition = definition;
  }

  getID(): string {
    return this.getDefaultedField("_id");
  }

  getName(): string {
    return this.getDefaultedField("_name");
  }

  getFieldName(): string {
    return this.getDefaultedField("_fieldName");
  }

  getTableName(): string {
    return this.getDefaultedField("_tableClass");
  }

  getI18nKey(): string {
    return this.getDefaultedField("_i18nKey");
  }

  getScript(): string {
    return this.getDefaultedField("_script");
  }

  getOnCreate(): boolean {
    return this.getDefaultedField("_onCreate", true);
  }

  getOnUpdate(): boolean {
    return this.getDefaultedField("_onUpdate", true);
  }

  getOnDelete(): boolean {
    return this.getDefaultedField("_onDelete", false);
  }

  getOrder() {
    return this.getDefaultedField("_order");
  }

  private getDefaultedField(property: any, defaultValue?: any) {
    const value = this.definition[property];
    return value !== null && value !== undefined ? value : defaultValue;
  }

  static create(definition: RelationshipDefinition): FieldValidationScriptModel {
    return new FieldValidationScriptModel(definition);
  }

}
